// src/utils/resolveEmpresaSelecionada.js
// Resolve o escopo de empresa para telas que precisam de empresa.
// Prioridade:
// 1) Empresa escolhida no EmpresaContext (empresaAtual.id)
// 2) usuario.empresaId (caso exista no perfil)
// 3) Se empresaAtual tiver só nome, tenta casar com usuario.empresasPermitidas
// 4) Se usuario.empresasPermitidas tiver apenas 1 empresa, usa ela

function norm(v) {
  return (v ?? "").toString().trim();
}

function normLower(v) {
  return norm(v).toLowerCase();
}

export function resolveEmpresaSelecionada(usuario, empresaAtual) {
  const grupoId = usuario?.grupoId ?? usuario?.perfil?.grupoId ?? null;

  const empresas = Array.isArray(usuario?.empresasPermitidas)
    ? usuario.empresasPermitidas
    : [];

  // 1) EmpresaContext (preferência do usuário)
  if (empresaAtual && typeof empresaAtual === "object") {
    const id = empresaAtual.id ?? empresaAtual.empresaId ?? empresaAtual.empresaID ?? null;
    const nome = empresaAtual.nome ?? empresaAtual.empresaNome ?? null;

    const idOk = id ? String(id) : null;
    if (idOk) {
      const match = empresas.find((e) => String(e?.id || "") === idOk);
      return {
        grupoId,
        empresaId: idOk,
        empresaNome: match?.nome || norm(nome) || null,
      };
    }

    const nomeOk = norm(nome);
    if (nomeOk) {
      const match = empresas.find(
        (e) => normLower(e?.nome) === normLower(nomeOk)
      );
      if (match?.id) {
        return {
          grupoId,
          empresaId: String(match.id),
          empresaNome: match.nome || nomeOk,
        };
      }

      // Se só existir 1 empresa permitida, não faz sentido bloquear o usuário
      if (empresas.length === 1 && empresas[0]?.id) {
        return {
          grupoId,
          empresaId: String(empresas[0].id),
          empresaNome: empresas[0].nome || null,
        };
      }

      return { grupoId, empresaId: null, empresaNome: nomeOk };
    }
  }

  // 2) Campo empresaId no perfil do usuário
  const perfilEmpresaId = usuario?.empresaId ?? usuario?.perfil?.empresaId ?? null;
  if (perfilEmpresaId) {
    const idOk = String(perfilEmpresaId);
    const match = empresas.find((e) => String(e?.id || "") === idOk);
    return {
      grupoId,
      empresaId: idOk,
      empresaNome: match?.nome || usuario?.empresaNome || null,
    };
  }

  // 4) Se só há 1 empresa permitida, usa ela como padrão
  if (empresas.length === 1 && empresas[0]?.id) {
    return {
      grupoId,
      empresaId: String(empresas[0].id),
      empresaNome: empresas[0].nome || null,
    };
  }

  return { grupoId, empresaId: null, empresaNome: null };
}
